var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.printers
    ? _c("div", { staticClass: "dashboard-table-wrapper" }, [
        _c("div", [
          _c(
            "table",
            { staticClass: "dashboard-table", attrs: { id: "printer-table" } },
            [
              _c("thead", [
                _c(
                  "tr",
                  [
                    _c("th", [_vm._v(" ")]),
                    _vm._v(" "),
                    _vm._l(_vm.printers[0], function(item, key) {
                      return key !== "manufacturer"
                        ? _c(
                            "th",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.sort(key)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " + _vm._s(key) + "\n          "
                              ),
                              _vm.currentSort === key &&
                              _vm.currentSortDir == "desc"
                                ? _c("i", { staticClass: "fas fa-arrow-down" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentSort === key &&
                              _vm.currentSortDir == "asc"
                                ? _c("i", { staticClass: "fas fa-arrow-up" })
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.sortedPrinters, function(printer) {
                  return _c(
                    "tr",
                    [
                      _c(
                        "td",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn btn-sm btn-warning",
                              attrs: {
                                to: {
                                  name: "printers.edit",
                                  params: { id: printer.id }
                                },
                                tag: "a"
                              }
                            },
                            [_vm._v("Edit")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(printer, function(value, key) {
                        return key !== "manufacturer"
                          ? _c("td", [
                              key === "manufacturer_id"
                                ? _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(printer.manufacturer.name) +
                                        "\n            "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              key !== "manufacturer_id"
                                ? _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(value) +
                                        "\n            "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-472d1514", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-472d1514","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Printers/Index.vue
// module id = null
// module chunks = 